import { Grid } from '@material-ui/core';
import React, { } from 'react';

export const EntityListContainer = ({ children }) => (
  React.createElement(Grid, { item: true, xs: 12, lg: 10,}
    , children
  )
);
